var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRe404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 500",
    style: {
      enableBackground: "new 0 0 800 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#5BAADE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.1,272.6c7,0,12.7,5.7,12.7,12.7s-5.7,12.7-12.7,12.7h-8.7v23.7c0,7.7-6.5,14.2-14.2,14.2 c-7.7,0-14.2-6.5-14.2-14.2v-23.7h-63.5c-7,0-12.7-5.7-12.7-12.7c0-2.7,0.8-4.7,2.2-7l76.2-107.7c2.5-3.5,6.7-6.5,12-6.5 c7.7,0,14.2,6.5,14.2,14.2v94.2H336.1z M298.9,272.6v-57.5l-39.5,57.5H298.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M496.8,249.9c0,60-20.7,87.7-65.2,87.7c-45,0-65.5-27.7-65.5-87.7c0-59.7,20.5-87.5,65.5-87.5 C476.1,162.4,496.8,190.1,496.8,249.9z M468.3,249.9c0-43.5-11-62.5-36.7-62.5s-37,19-37,62.5c0,44,11.2,62.5,37,62.5 S468.3,293.9,468.3,249.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M629,272.6c7,0,12.7,5.7,12.7,12.7s-5.7,12.7-12.7,12.7h-8.7v23.7c0,7.7-6.5,14.2-14.2,14.2 c-7.7,0-14.2-6.5-14.2-14.2v-23.7h-63.5c-7,0-12.7-5.7-12.7-12.7c0-2.7,0.7-4.7,2.2-7L594,170.7c2.5-3.5,6.7-6.5,12-6.5 c7.7,0,14.2,6.5,14.2,14.2v94.2H629z M591.8,272.6v-57.5l-39.5,57.5H591.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "st1",
    d: "M203.8,232.3c0,6.2-2.3,11.9-6.6,16.2s-10.3,6.9-16.4,6.6c-5.9,0-11.9-2.3-16-6.6 c-8.7-8.9-8.7-23.3,0-32.2c4.1-4.3,9.8-6.9,16-6.6c6.2-0.2,12.1,2.3,16.4,6.6C201.3,220.4,203.8,226.1,203.8,232.3 M203.8,296.7 c0,6.2-2.3,11.9-6.6,16.2c-4.3,4.3-10.3,6.9-16.4,6.6c-5.9,0-11.9-2.3-16-6.6c-8.7-8.9-8.7-23.3,0-32.2c4.1-4.3,9.8-6.9,16-6.6 c6.2-0.2,12.1,2.3,16.4,6.6C201.3,284.8,203.8,290.7,203.8,296.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRe404);
export default __webpack_public_path__ + "static/media/re-404.947717578a21ea373607c47ceda295eb.svg";
export { ForwardRef as ReactComponent };